(function () {
    function initTOC() {
        const content = document.querySelector('.gh-content');
        const tocContainer = document.getElementById('vanta-toc');
        const tocList = document.getElementById('vanta-toc-list');

        if (!content || !tocContainer || !tocList) return;

        const headings = content.querySelectorAll('h1, h2, h3, h4');
        if (!headings || headings.length === 0) {
            tocContainer.style.display = 'none';
            return;
        }

        tocList.innerHTML = '';
        var count = 0;

        headings.forEach(function (heading, index) {
            var text = heading.textContent ? heading.textContent.trim() : '';
            if (!text) return;

            if (!heading.id) {
                heading.id = 'heading-' + index;
            }

            const li = document.createElement('li');
            var tag = heading.tagName.toLowerCase();
            if (tag === 'h3') {
                li.style.paddingLeft = '16px';
            } else if (tag === 'h4') {
                li.style.paddingLeft = '32px';
            }

            const link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = text;

            li.appendChild(link);
            tocList.appendChild(li);
            count++;
        });

        if (count > 0) {
            tocContainer.style.display = 'block';
        } else {
            tocContainer.style.display = 'none';
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTOC);
    } else {
        initTOC();
    }
})();
